import { render, staticRenderFns } from "./TeachingDynamics.vue?vue&type=template&id=508bcd73&scoped=true"
import script from "./TeachingDynamics.vue?vue&type=script&lang=js"
export * from "./TeachingDynamics.vue?vue&type=script&lang=js"
import style0 from "./TeachingDynamics.vue?vue&type=style&index=0&id=508bcd73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508bcd73",
  null
  
)

export default component.exports